import { render, staticRenderFns } from "./ValanceDisclaimer.vue?vue&type=template&id=5223f218&scoped=true&"
import script from "./ValanceDisclaimer.vue?vue&type=script&lang=ts&"
export * from "./ValanceDisclaimer.vue?vue&type=script&lang=ts&"
import style0 from "./ValanceDisclaimer.vue?vue&type=style&index=0&id=5223f218&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5223f218",
  null
  
)

export default component.exports